var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrepaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#FFF9DD",
    stroke: "#FFE673",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7309 21.9701C36.7309 19.2557 34.522 17 31.8076 17C30.7499 17 29.7615 17.4526 28.9944 18.2672C28.2271 17.4526 27.2388 17 26.1811 17C23.4667 17 21.2578 19.2557 21.2578 21.9701C21.2578 24.7003 23.2613 26.1097 25.5815 27.7423C26.5382 28.4154 27.528 29.1119 28.5335 29.9842L28.9937 30.3839L29.4545 29.9848C30.5912 29.0013 31.6723 28.2313 32.6257 27.552C34.919 25.9195 36.7309 24.6296 36.7309 21.9701ZM31.1043 24.0801H29.6977V25.4868H28.291V24.0801H26.8844V22.6735H28.291V21.2668H29.6977V22.6735H31.1043V24.0801Z",
    fill: "url(#paint0_linear_1351_3020)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1514 23.4336C38.7166 23.4336 38.3462 30.1011 38.318 30.2418C38.1752 31.2188 37.4869 32.665 36.3247 33.5358L33.2783 35.7476L32.4349 34.6212L35.4813 32.41C36.688 31.5053 37.238 29.9604 35.7298 29.9604C34.3791 29.9604 31.8542 31.5243 31.1057 32.1447C30.2118 32.8855 29.6953 33.9862 29.6953 35.1472V41.0073H33.9152C33.9152 40.3321 34.281 39.5959 34.8436 38.8926C35.4344 38.119 36.2784 37.3312 37.1505 36.5295C38.8103 34.9681 40.5311 33.3645 40.7562 31.7328C40.8899 30.6368 41.0008 28.7569 40.9953 27.0815C40.9892 25.2053 40.8303 23.4942 40.1514 23.4336Z",
    fill: "url(#paint1_linear_1351_3020)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7194 32.0132C24.736 30.6487 23.2309 29.9594 22.2604 29.9594C20.7522 29.9594 21.3021 31.5043 22.5089 32.4091L25.5553 34.6203L24.7119 35.7467L21.6655 33.5348C20.5031 32.664 19.8149 31.2178 19.672 30.2408C19.6439 30.1001 19.2735 23.4326 17.8387 23.4326C17.0509 23.5029 16.9665 25.7958 17.0088 27.9901C17.037 29.5937 17.1635 31.1551 17.2338 31.7319C17.4589 33.3635 19.1797 34.9671 20.8395 36.5285C21.7117 37.3303 22.5556 38.118 23.1464 38.8916C23.7091 39.595 24.0748 40.3311 24.0748 41.0063H28.2947V35.1743C28.2948 33.9317 27.7115 32.7612 26.7194 32.0132Z",
    fill: "url(#paint2_linear_1351_3020)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_3020",
    x1: 24.8378,
    y1: 24.5671,
    x2: 36.6197,
    y2: 24.5638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_3020",
    x1: 32.3098,
    y1: 33.3696,
    x2: 40.9143,
    y2: 33.3683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_3020",
    x1: 19.6132,
    y1: 33.3686,
    x2: 28.2136,
    y2: 33.3673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaid);
export default __webpack_public_path__ + "static/media/Prepaid.ed1deb1148ea0b017115e13d15ab61c9.svg";
export { ForwardRef as ReactComponent };